// extracted by mini-css-extract-plugin
export default {"datatable":"listing_datatable__-FpLU","spinner":"listing_spinner__L5UXc","fixedTable":"listing_fixedTable__PyhYd","fixedCell":"listing_fixedCell__9ifrY"};